module.exports = __webpack_public_path__ + "img/wording-1.56c28f9d.png";